/**
 * Type predicate to determine that a value is not `null` or `undefined`.
 */
export function isNonNullish<T>(value: T | null | undefined): value is T {
	return value != null;
}
